import { render, staticRenderFns } from "./CbxPolicyStatus.vue?vue&type=template&id=57a5c7e2&"
import script from "./CbxPolicyStatus.vue?vue&type=script&lang=ts&"
export * from "./CbxPolicyStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports